import mutations from './mutations'
import actions from './actions'

const roles = {
    namespaced: true,
    state: {
        roles: [],
        rolesList: [],
        permissions: [],
        isLoaded: false,
        pagination: {
            page: 1,
            length: null,
            total: null
        },
        filters: {
            fromDate: null,
            toDate: null,
            name: null
        }
    },
    mutations,
    actions
}

export default roles
